import React, { useCallback } from 'react';
import { Button } from 'antd';
import { useSelector } from 'react-redux';
import { permissionCodeSelector } from 'src/selector/user';
import { modalMethods } from '../POSModal';
import { getSessionItem, USER_KEYS } from 'src/store/storage';

const AuthorizedButton = ({ actionCode, errorMsgId = 'access-declined', onClick, children, ...other }) => {
  const { permissionCodes } = useSelector(permissionCodeSelector);

  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();
      if (typeof onClick !== 'function') return;
      const hasPOSContract = JSON.parse(getSessionItem(USER_KEYS.signedPOSContract));

      if (!hasPOSContract || !actionCode || permissionCodes.includes(actionCode)) {
        onClick(e);
        return;
      }

      modalMethods.show({ messageId: errorMsgId });
    },
    [permissionCodes, onClick, actionCode]
  );

  return (
    <Button {...other} onClick={handleClick}>
      {children}
    </Button>
  );
};

export default AuthorizedButton;
